import React, { useState, useEffect } from "react";
import { Button, Modal } from "react-bootstrap";
import axios from "axios";
import routes from "../../../app/routes";
import Form from "./Form";
import Table from "./Table";

export default function IndexCycles({
  className,
  buttonName,
  teamId,
  showMembers,
}) {
  const [show, setShow] = useState(false);
  const [collection, setCollection] = useState([]);

  const [loaded, setLoaded] = useState(false);
  const [initialFormValues, setInitialFormValues] = useState({});

  const closeForm = () => setShow(false);
  const openForm = () => {
    setShow(true);
    const tooltips = document.querySelectorAll(".tooltip.in");
    tooltips.forEach((box) => {
      box.remove();
    });
  };

  const vbReport = () => {
    setLoaded(true);
    axios.get(routes.api.enterprises.vb_report).then((resp) => {
      swal({
        title: "",
        text:
          "Voluntary Benefit Report will be updated soon. Please, open Google Sheet and check the update in a couple of minutes.",
      });
      setLoaded(false);
    });
  };

  const updateCollection = () => {
    setLoaded(true);
    axios.get(routes.api.cycles.list(teamId)).then((resp) => {
      setCollection(resp.data.data);
      setLoaded(false);
    });
  };

  const createData = () => {
    const number = Math.max(
      ...collection.map((cycle) => parseInt(cycle.attributes.number)),
      0
    );

    setInitialFormValues({
      id: null,
      number: number + 1,
      cycleStart: "",
      cycleEnd: "",
      gracePeriod: "",
      current: false,
    });
    openForm();
  };

  const editData = (data) => {
    setInitialFormValues({
      id: data.id,
      number: data.attributes.number,
      cycleStart: data.attributes.form_format_cycle_start,
      cycleEnd: data.attributes.form_format_cycle_end,
      gracePeriod: data.attributes.grace_period,
      current: data.attributes.current == "Yes",
    });
    openForm();
  };

  useEffect(() => {
    updateCollection();
  }, []);

  return (
    <>
      <div className="row">
        <div className="col-md-8">
          <h2>Enrollment Cycles</h2>
        </div>
        <div className="col-md-4 text-right">
          <Button className="mr10" bsStyle="primary" onClick={vbReport}>
            VB Report
          </Button>
          <Button bsStyle="primary" onClick={createData}>
            {buttonName}
          </Button>
          <Modal
            className="student inmodal auto without-overflow"
            show={show}
            onHide={closeForm}
          >
            <Modal.Header closeButton>
              <Modal.Title>
                {initialFormValues.id == null
                  ? "Add Enrollment Cycle"
                  : "Edit Enrollment Cycle"}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form
                closeForm={closeForm}
                teamId={teamId}
                updateCollection={updateCollection}
                initialFormValues={initialFormValues}
              />
            </Modal.Body>
          </Modal>
        </div>
      </div>
      <div>
        {loaded && <p className="text-center mt20">Processing...</p>}
        {!loaded && (
          <Table
            teamId={teamId}
            collection={collection}
            updateCollection={updateCollection}
            editData={editData}
            showMembers={showMembers}
          />
        )}
      </div>
    </>
  );
}
